import { useIsLocalDeliveryServiceSelectedForFulfillmentPlan } from '../../../../hooks/use-is-local-delivery-service-selected-for-fulfillment-plan';
import { ACCESS_LEVELS, useRequiresRateShopperAccessLevel } from '../../../../hooks/use-has-rate-shopper-access-level';
import { EXTERNAL_FULFILLMENTS } from '../../../../enums/csw-types';
import { useFulfillmentPlanRateInfo } from '../use-fulfillment-plan-rate-info';
import { useIsLocalDeliveryServiceSelected } from '../../../../fulfillment-planner/hooks/use-is-local-delivery-service-selected';

export const useServiceDetails = (
  fulfillmentPlanId,
  serviceIdAndSellerLabelProviderId,
  serviceCollectionGuid,
  cswTypeId,
  fulfillmentServiceId,
) => {
  const isPickupServiceSelectedInEntities = useIsLocalDeliveryServiceSelectedForFulfillmentPlan(fulfillmentPlanId);
  const isPickupServiceSelectedInCSW = useIsLocalDeliveryServiceSelected();
  const isPickupServiceSelected = isPickupServiceSelectedInEntities || isPickupServiceSelectedInCSW;
  const { serviceId, sellerLabelProviderId } = serviceIdAndSellerLabelProviderId || {};
  const { isThirdPartyBilling, hasProvidedRate } = useFulfillmentPlanRateInfo(serviceId);
  const hasRateShopperAccess = useRequiresRateShopperAccessLevel(ACCESS_LEVELS.FREEMIUM);
  const shouldShowRateShopperSelectedService = hasRateShopperAccess && !!serviceCollectionGuid;
  const isMissingShippingService = !serviceId && !serviceCollectionGuid && !sellerLabelProviderId && !hasProvidedRate;
  const isMissingFulfillmentService = cswTypeId === EXTERNAL_FULFILLMENTS && !fulfillmentServiceId;
  const isMissingService = isMissingShippingService && isMissingFulfillmentService;

  return {
    isPickupServiceSelected,
    isThirdPartyBilling,
    hasProvidedRate,
    shouldShowRateShopperSelectedService,
    isMissingService,
  };
};
